module.exports = __webpack_public_path__ + "static/media/baseMeme8.d28b5d05.jpg";